var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTextAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 947,
    height: 401,
    viewBox: "0 0 947 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.877 320.384C355.277 320.384 411.537 266.572 411.537 200.192C411.537 133.812 355.277 80 285.877 80C216.477 80 160.217 133.812 160.217 200.192C160.217 266.572 216.477 320.384 285.877 320.384ZM285.877 303.774C345.687 303.774 394.172 257.399 394.172 200.192C394.172 142.985 345.687 96.6094 285.877 96.6094C226.068 96.6094 177.582 142.985 177.582 200.192C177.582 257.399 226.068 303.774 285.877 303.774Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M242.037 192.599L294.46 120.928H346.083L295.696 171.928H315.42L275.025 216.027H300.347L225.672 279.161L245.223 240.23H227.308L273.216 192.599H242.037Z",
    fill: "#ED2124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.537 300.192V100.192H545.801V252.13H587.661V300.192H491.537Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M603.165 300.192V100.192H657.429V300.192H603.165Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M671.624 147.479V100.192H786.111V147.479H755.878V300.192H701.615V147.479H671.624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextAlt);
export default __webpack_public_path__ + "static/media/logoTextAlt.11deaea87d1a7a4aea4e8ae525503371.svg";
export { ForwardRef as ReactComponent };